import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "iCrack Solutions — Phone & Computer Repair Specialist, Eastleigh";

const META = {
  "/": {
    title: BASE_TITLE,
    desc: "Fast phone, iPad, MacBook & laptop repair in Eastleigh. Walk-in same-day repairs + mobile call-out across Eastleigh, Southampton, Hampshire & Surrey. £120/hr + parts. No call-out charge. 4.9★ (294 Google reviews).",
  },
  "/services": {
    title: "Repair Services — iPhone, Android, iPad, MacBook, PC | iCrack Solutions",
    desc: "Complete list of repair services: iPhone, Android, iPad, MacBook, laptop, battery, water damage, charging port, buy & sell phones. Eastleigh, Hampshire.",
  },
  "/book": {
    title: "Book a Repair — iCrack Solutions Eastleigh",
    desc: "Book your phone, tablet, Mac or laptop repair online. In-store or mobile call-out across Eastleigh, Southampton, Hampshire & Surrey.",
  },
  "/call-out": {
    title: "Mobile Call-Out Repair Service — Eastleigh, Southampton, Hampshire & Surrey",
    desc: "Our technician comes to you — home or office. No call-out charge. Coverage across Eastleigh, Southampton, Hampshire and Surrey. Book today.",
  },
  "/contact": {
    title: "Contact iCrack Solutions — 94 Market Street, Eastleigh SO50 5RE",
    desc: "Call 07930 305 875 or 07898 873 615 • WhatsApp • email info@icracksolutions.co.uk. Visit 94 Market Street, Eastleigh, SO50 5RE.",
  },
  "/faq": {
    title: "FAQs — Repair times, warranty, prices | iCrack Solutions",
    desc: "Frequently asked questions about phone, iPad, MacBook & laptop repairs in Eastleigh: turnaround, pricing, warranty, call-out, data safety.",
  },
  "/areas": {
    title: "Areas We Cover — Hampshire & Surrey | iCrack Solutions",
    desc: "Mobile phone, tablet, MacBook and laptop repair across Eastleigh, Southampton, Winchester, Fareham, Portsmouth, Guildford, Woking, Farnborough and more.",
  },
};

export default function SEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    // The canonical is set for every route, including /areas/:slug — those pages
    // set their own title/description but not this, and leaving it behind would
    // point them at whichever page was rendered before.
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.origin + pathname);

    // Title and description for /areas/:slug come from AreaPage itself.
    if (pathname.startsWith("/areas/") && pathname !== "/areas") return;
    const meta = META[pathname] || META["/"];
    document.title = meta.title;
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", meta.desc);
    setMeta("og:title", meta.title, "property");
    setMeta("og:description", meta.desc, "property");
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.desc);
  }, [pathname]);
  return null;
}
